import { useEffect, useRef } from 'react';
import { useSearchStore } from '../../store/useSearchStore';
import { IonIcon, useIonRouter } from '@ionic/react';
import { searchOutline, closeOutline } from 'ionicons/icons';
import { SearchResult, filterSearchResults } from '../../utils/searchContent';

interface SearchBarProps {
  variant?: 'desktop' | 'mobile';
  onResultClick?: () => void;
}

export function SearchBar({ variant = 'desktop', onResultClick }: SearchBarProps) {
  const router = useIonRouter();
  const query = useSearchStore((state) => state.query);
  const results = useSearchStore((state) => state.results);
  const isSearchFocused = useSearchStore((state) => state.isFocused);

  const setQuery = useSearchStore((state) => state.setQuery);
  const setResults = useSearchStore((state) => state.setResults);
  const setIsSearchFocused = useSearchStore((state) => state.setFocused);

  const searchRef = useRef<HTMLDivElement>(null);

  // Search function - filters as user types
  useEffect(() => {
    const searchResults = filterSearchResults(query);
    setResults(searchResults);
  }, [query]);

  // Close search dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setIsSearchFocused(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearchResultClick = (path: string) => {
    router.push(path, 'none');
    setQuery('');
    setResults([]);
    setIsSearchFocused(false);

    // Call optional callback (useful for closing mobile menu)
    if (onResultClick) {
      onResultClick();
    }
  };

  const handleClearSearch = () => {
    setQuery('');
    setResults([]);
  };

  return (
    <>
      {/* Backdrop */}
      {isSearchFocused && (results.length > 0 || (query && results.length === 0)) && (
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40"
          onClick={() => setIsSearchFocused(false)}
        />
      )}

      {/* <div ref={searchRef} className={`relative w-full ${variant === 'desktop' ? 'max-w-md' : ''} ${isSearchFocused ? 'z-50' : ''}`}>
        <div className="relative">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onFocus={() => setIsSearchFocused(true)}
            placeholder="Search..."
            className="w-full px-3 py-1 pl-8 pr-3 border rounded-lg text-sm"
          />

          <IonIcon
            icon={searchOutline}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4"
          />

          {query && (
            <button
              onClick={handleClearSearch}
              className="absolute right-3 top-1/2 transform -translate-y-1/2"
              aria-label="Clear search"
            >
              <IonIcon icon={closeOutline} className="w-4 h-4" />
            </button>
          )}
        </div>

        {isSearchFocused && results.length > 0 && (
          <div className="absolute top-full mt-2 w-full border rounded-lg shadow-lg z-50 max-h-96 overflow-hidden" style={{ backgroundColor: 'var(--ion-background-color)' }}>
            {results.map((result, index) => (
              <button
                key={`${result.path}-${index}`}
                onClick={() => handleSearchResultClick(result.path)}
                className="w-full text-left px-4 py-3 border-b last:border-b-0"
              >
                <div className="flex items-start gap-4">
                  <span>
                    {result.type === 'page' && '📄'}
                    {result.type === 'section' && '📂'}
                    {result.type === 'content' && '📝'}
                  </span>
                  <div className="flex-1">
                    <div>{result.title}</div>
                    {result.description && (
                      <div>{result.description}</div>
                    )}
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}

        {isSearchFocused && query && results.length === 0 && (
          <div className="absolute top-full mt-2 w-full border rounded-lg shadow-lg z-50 px-4 py-3" style={{ backgroundColor: 'var(--ion-background-color)' }}>
            <p>No results found for "{query}"</p>
          </div>
        )}
      </div> */}
    </>
  );
}

